import Vue from "vue";

// Import main styles
import "./sass/main.scss";
import VueMq from "vue-mq";
// Import bootstrap collapse component
import "./js/bootstrap/collapse";
import "./js/bootstrap/tab";

import BaseButton from "./components/base-button/BaseButton.vue";
import BaseLink from "./components/base-link/BaseLink.vue";
import AboutIntroSection from "./components/about/AboutIntroSection.vue";
import ChannelsSection from "./components/channels-section/ChannelsSection.vue";
import MainBanner from "./components/banner/MainBanner.vue";
import ClubsSection from "./components/clubs-section/ClubsSection.vue";
import AboutTeamSection from "./components/about/AboutTeamSection.vue";
import ContactForm from "./components/contact/ContactForm.vue";
import ChannelsSectionBox from "./components/channels-section/ChannelsSectionBox.vue";
import HeaderButtons from "./components/header/HeaderButtons.vue";
import HeaderHamburgerButton from "./components/header/HeaderHamburgerButton.vue";
import HeaderLogo from "./components/header/HeaderLogo.vue";
import HeaderMobileMenu from "./components/header/HeaderMobileMenu.vue";
import HeaderNav from "./components/header/HeaderNav.vue";
import FaqSection from "./components/faq-section/FaqSection.vue";
import PricingSection from "./components/pricing/PricingSection.vue";
import PricingBox from "./components/pricing/PricingBox.vue";
import PricingBoxes from "./components/pricing/PricingBoxes.vue";
import CustomPricingBox from "./components/pricing/CustomPricingBox.vue";
import BaseAccordion from "./components/accordion/BaseAccordion.vue";
import MainHero from "./components/hero/MainHero.vue";
import SecondaryHero from "./components/hero/SecondaryHero.vue";
import VideoSection from "./components/video-section/VideoSection.vue";
import HowItWorks from "./components/how-it-works/HowItWorks.vue";
import BenefitsSection from "./components/benefits/BenefitsSection.vue";
import SuccessSection from "./components/success-section/SuccessSection.vue";
import BenefitBox from "./components/benefits/BenefitBox.vue";
import SuccessBox from "./components/success-section/SuccessBox.vue";
import IntroSectionText from "./components/IntroSectionText.vue";
import CardBox from "./components/card-box/CardBox.vue";
import RolesSection from "./components/roles-section/RolesSection.vue";
import RolesBox from "./components/roles-box/RolesBox.vue";
import Modal from "./components/modal/Modal.vue";
import FeaturesSection from "./components/features-section/FeaturesSection.vue";
import FeaturesSectionBox from "./components/features-section/FeaturesSectionBox.vue";

// import { Navigation, Pagination } from 'swiper'
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
import SwiperSlider from "./components/slider/SwiperSlider.vue";

// Import Swiper styles
import "swiper/swiper-bundle.css";

// SwiperCore.use([Navigation, Pagination])

const ProductPage = () => import("./pages/ProductPage");
const FeaturesPage = () => import("./pages/FeaturesPage")
const PricingPage = () => import("./pages/PricingPage");
const AboutPage = () => import("./pages/AboutPage");
const ClubsPage = () => import("./pages/ClubsPage");
const LeaguesPage = () => import("./pages/LeaguesPage");
const FederationsPage = () => import("./pages/FederationsPage");
const TournamentsPage = () => import("./pages/TournamentsPage");
const MainHeader = () => import("./components/header/MainHeader");
const MainFooter = () => import("./components/footer/MainFooter");

Vue.component("SwiperSlider", SwiperSlider);
Vue.component("swiper-slide", SwiperSlide);
Vue.component("swiper-container", Swiper);
Vue.component("SuccessBox", SuccessBox);
Vue.component("MainHero", MainHero);
Vue.component("SecondaryHero", SecondaryHero);
Vue.component("VideoSection", VideoSection);
Vue.component("HowItWorks", HowItWorks);
Vue.component("BenefitsSection", BenefitsSection);
Vue.component("BenefitBox", BenefitBox);
Vue.component("BaseAccordion", BaseAccordion);
Vue.component("SuccessSection", SuccessSection);
Vue.component("FaqSection", FaqSection);
Vue.component("PricingSection", PricingSection);
Vue.component("PricingBox", PricingBox);
Vue.component("PricingBoxes", PricingBoxes);
Vue.component("CustomPricingBox", CustomPricingBox);
Vue.component("HeaderButtons", HeaderButtons);
Vue.component("HeaderHamburgerButton", HeaderHamburgerButton);
Vue.component("HeaderLogo", HeaderLogo);
Vue.component("HeaderMobileMenu", HeaderMobileMenu);
Vue.component("HeaderNav", HeaderNav);
Vue.component("main-header", MainHeader);
Vue.component("main-footer", MainFooter);
Vue.component("BaseButton", BaseButton);
Vue.component("BaseLink", BaseLink);
Vue.component("ChannelsSectionBox", ChannelsSectionBox);
Vue.component("AboutIntroSection", AboutIntroSection);
Vue.component("AboutTeamSection", AboutTeamSection);
Vue.component("ContactForm", ContactForm);
Vue.component("ClubsSection", ClubsSection);
Vue.component("ChannelsSection", ChannelsSection);
Vue.component("MainBanner", MainBanner);
Vue.component("IntroSectionText", IntroSectionText);
Vue.component("CardBox", CardBox);
Vue.component("RolesSection", RolesSection);
Vue.component("RolesBox", RolesBox);
Vue.component("Modal", Modal);
Vue.component("FeaturesSection", FeaturesSection);
Vue.component("FeaturesSectionBox", FeaturesSectionBox);
Vue.component("product-page", ProductPage);
Vue.component("features-page", FeaturesPage);
Vue.component("pricing-page", PricingPage);
Vue.component("about-page", AboutPage);
Vue.component("clubs-page", ClubsPage);
Vue.component("leagues-page", LeaguesPage);
Vue.component("federations-page", FederationsPage);
Vue.component("tournaments-page", TournamentsPage);

Vue.use(VueMq, {
	breakpoints: {
		sm: 768,
		md: 992,
		lg: 1200,
	},
});

Vue.prototype.$auth_status = {"authenticated_broadcaster": window.authenticated_broadcaster,
	"authenticated_viewer": window.authenticated_viewer,
	"authenticated_viewer_only": window.authenticated_viewer_only,
	"authenticated_paying_broadcaster": window.authenticated_paying_broadcaster,
	"authenticated": window.authenticated,
	"country_slug": window.country_slug}

Vue.prototype.$trial_countries = window.TRIAL_COUNTRIES


new Vue({
	el: "#app",
});
